module.exports = __webpack_public_path__ + "assets/img/dj.25c66f4d.png";